import { minorUnits, normalizeCurrency } from './currencies';

export function currencySymbol(currency: string | null | undefined): string {
  const code = normalizeCurrency(currency);
  const part = new Intl.NumberFormat('en', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' })
    .formatToParts(0)
    .find(p => p.type === 'currency');
  return part?.value ?? code;
}

// "1 500 ₴", "12,50 €", "1,500 $" (en). Whole amounts drop the decimals.
export function formatPrice(amount: number, currency: string | null | undefined, lang: 'uk' | 'en' = 'uk'): string {
  const code = normalizeCurrency(currency);
  const digits = minorUnits(code);
  const number = new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'uk-UA', {
    minimumFractionDigits: Number.isInteger(amount) ? 0 : digits,
    maximumFractionDigits: digits,
  }).format(amount).replace(/[  ]/g, ' ');
  return `${number} ${currencySymbol(code)}`;
}
